import styled from 'styled-components'

const StyledButton = styled.a`
  background: var(--btn-bg-color);
  color: var(--btn-text-color);
  padding: 15px;
  border-radius: var(--btn-border-radius);
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 20px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: var(--btn-border-width) var(--btn-border-style)
    var(--btn-border-color);
  transition: all 0.15s;

  span {
    display: block;
    font-weight: normal;
    margin-top: 5px;
    font-size: 14px;
    color: var(--btn-subtext-color);
  }

  :hover {
    background-color: var(--btn-hover-bg-color);
    color: var(--btn-hover-text-color);
  }

  :hover span {
    color: var(--btn-hover-text-color);
  }
`

function Button(props) {
  return (
    <StyledButton
      href={props.url}
      className={props.className}
      onClick={props.onClick}
    >
      {props.children}
    </StyledButton>
  )
}

export default Button
